import React from 'react';
import {
  GraphExportType,
} from '../../Utils';
import {
  TextLayout,
  TextLayoutType,
} from '../newChart/otherTypes';
import {
  heightProportionReservedForShare,
  labelHorizontalMargin,
  labelTopMargin,
} from '../newChart/transformUtils';

import {
  textColor,
} from './Utils';

interface IProps {
  id: string;
  textLayout: TextLayout;
  x0: number;
  y0: number;
  x1: number;
  y1: number;
  exportType: GraphExportType;
}

export default (props: IProps) => {
  const {textLayout, x0, y0, x1, y1, exportType, id} = props;

  const cellWidth = x1 - x0;
  const cellHeight = y1 - y0;

  if (textLayout.type === TextLayoutType.ShowNone) {
    return null;
  } else if (textLayout.type === TextLayoutType.ShowBoth) {
    const {label, share} = textLayout;

    const heightAvailableForLabel = cellHeight * (1 - heightProportionReservedForShare);

    //#region Cell name
    let labelElem: React.ReactElement<any> | null;
    if (label.showText === true) {
      const lineheight = label.fontSize;
      const fontSize = label.fontSize;
      const verticalTopLimitOfTextArea = (label.useMargin) ? y0 + labelTopMargin * cellHeight : y0;

      let baselineOfFirstLineOfText: number;
      let alignmentBaseline: 'middle' | 'auto';
      if (exportType === GraphExportType.SVG) {
        baselineOfFirstLineOfText = verticalTopLimitOfTextArea + lineheight * 0.5;
        alignmentBaseline = 'middle';
      } else {
        baselineOfFirstLineOfText = verticalTopLimitOfTextArea + lineheight * 0.5 + lineheight / 4;
        alignmentBaseline = 'auto';
      }

      const horizontalStartOfText = label.useMargin ? x0 + cellWidth * labelHorizontalMargin : x0;
      const lines = label.textSplitIntoLines.map((text, index) => {
        const x = horizontalStartOfText;
        const y = baselineOfFirstLineOfText + index * lineheight;
        return (
          <tspan
            x={x} y={y} alignmentBaseline={alignmentBaseline} fontSize={fontSize}
            textAnchor='start' key={index}>{text}</tspan>
        );
      });

      labelElem = (
        <text fill={textColor}>
          {lines}
        </text>
      );
    } else {
      labelElem = null;
    }
    //#endregion

    //#region Cell percentage:

    let shareElem: React.ReactElement<any> | null;
    if (share.showText === true) {
      const heightAvailableForPercentage = cellHeight * heightProportionReservedForShare;
      const lineheight = share.fontSize;

      let baseline: number, alignmentBaseline: 'middle' | 'auto';
      if (exportType === GraphExportType.SVG) {
        // Align text's middle baseline with container's middle part:
        baseline = y0 + heightAvailableForLabel + heightAvailableForPercentage / 2;
        alignmentBaseline = 'middle';
      } else {
        baseline = y0 + heightAvailableForLabel + heightAvailableForPercentage / 2 + lineheight / 4;
        alignmentBaseline = 'auto';
      }
      const centerX = x0 + cellWidth / 2;
      shareElem = (
        <text textAnchor='middle' fill={textColor}>
          <tspan x={centerX} y={baseline} textAnchor='middle'
            alignmentBaseline={alignmentBaseline} fontSize={share.fontSize}>
            {share.text}
          </tspan>
        </text>
      );
    } else {
      shareElem = null;
    }

    //#endregion
    return (
      <>
        {labelElem}
        {shareElem}
      </>
    );
  } else {
    const {share} = textLayout;

    let shareElem: React.ReactElement<any> | null;
    if (share.showText === true) {
      const lineheight = share.fontSize;
      let baseline: number, alignmentBaseline: 'middle' | 'auto';
      if (exportType === GraphExportType.SVG) {
        // Align text's middle baseline with container's middle part:
        baseline = y0 + cellHeight / 2;
        alignmentBaseline = 'middle';
      } else {
        baseline = y0 + cellHeight / 2 + lineheight * 1 / 4;
        alignmentBaseline = 'auto';
      }
      const centerX = x0 + cellWidth / 2;
      shareElem = (
        <text textAnchor='middle' fill={textColor} key={`percentage-${id}`}>
          <tspan x={centerX} y={baseline} textAnchor='middle'
            alignmentBaseline={alignmentBaseline} fontSize={share.fontSize}>
            {share.text}
          </tspan>
        </text>
      );
    } else {
      shareElem = null;
    }

    return shareElem;
  }
};
